
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Urbaniahireforoutstationinpune() {



  const cardData =
  {
    keyword: ' Urbania Hire for Outstation in Pune',
    heading: 'Vaishnavi Travels: Urbania Hire for Outstation in Pune',
    headingDescription: 'Vaishnavi Travels offers dependable and affordable Urbania Hire for Outstation in Pune, perfect for family vacations, corporate tours, school trips, and pilgrimages. Our Force Urbania is well-maintained with spacious push-back seating, strong air-conditioning, modern interiors, and ample luggage capacity, ensuring a smooth and comfortable ride on long-distance routes. With professional chauffeurs, punctual service, and flexible booking options, we make outstation group travel stress-free and convenient. Whether it’s a holiday trip, religious yatra, or business tour, Vaishnavi Travels guarantees safe, reliable, and comfortable Urbania rental services for outstation journeys from Pune.',

    top: 'Top Places to Visit in Pune Outstation with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Lonavala and Khandala",
    "description": "Just 65 km from Pune, Lonavala and Khandala are the twin hill stations famous for lush valleys, waterfalls, and misty weather. Tourists enjoy spots like Bhushi Dam, Tiger’s Leap, Karla Caves, and Rajmachi Fort. The Mumbai-Pune Expressway drive itself is scenic and thrilling. Monsoon turns the ghats into a green paradise. Families, trekkers, and honeymooners flock here year-round. Lonavala-Khandala are Pune’s classic outstation weekend retreats."
  },
  {
    "title": "Mahabaleshwar and Panchgani",
    "description": "Located 120 km from Pune, Mahabaleshwar and nearby Panchgani are famous for strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Table Land. Venna Lake boating, Mapro Garden, and Tapola backwaters add charm. The old Mahabaleshwar Temple holds spiritual significance. The cool climate makes it a favorite summer escape. Monsoon enhances its beauty with waterfalls and misty landscapes. Mahabaleshwar-Panchgani are Pune’s refreshing hill station getaways."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi, around 200 km from Pune, is a world-famous pilgrimage town dedicated to Sai Baba. The Samadhi Mandir attracts lakhs of devotees every year. Other sacred sites include Dwarkamai, Chavadi, Lendi Baug, and Sai Museum. Pilgrims experience peace and devotion throughout the temple complex. The town also offers family-friendly attractions like Sai Heritage Village and Wet N Joy Water Park. Shirdi is Pune’s spiritual outstation destination of global importance."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Shani Shingnapur, 160 km from Pune, is a unique village temple dedicated to Lord Shani. The deity is worshipped in the open-air shrine without a roof. The village is famous for houses without doors, symbolizing trust in divine protection. Devotees believe that worship here brings discipline and justice in life. Many combine Shirdi and Shani Shingnapur in a single trip. The shrine is especially crowded on Saturdays. Shani Shingnapur is Pune’s sacred outstation landmark of faith."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, about 60 km from Pune, is India’s first planned hill city inspired by Italian architecture. Located on the banks of Warasgaon Lake, it offers lakeside promenades, colorful buildings, and luxury resorts. Tourists enjoy boating, cycling, and adventure activities. Its peaceful setting makes it ideal for couples and weekend getaways. The vibrant cityscape is also popular for photography. Lavasa is Pune’s modern outstation escape of leisure and romance."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, 140 km from Pune, is a coastal town famous for clean beaches and historic forts. Tourists relax at Alibaug, Kashid, and Nagaon beaches while enjoying water sports. The Kolaba Fort standing amidst the sea adds heritage charm. Fresh seafood and beach resorts make it a complete coastal experience. Weekend travelers often combine it with Murud-Janjira. Alibaug is Pune’s favorite seaside retreat for families and groups."
  },
  {
    "title": "Nashik",
    "description": "Nashik, 210 km from Pune, is India’s wine capital and a spiritual hub on the banks of the Godavari River. It is home to the famous Trimbakeshwar Jyotirlinga and hosts the world-renowned Kumbh Mela. Wine lovers enjoy vineyard tours at Sula and York wineries. The city’s mix of spirituality, history, and modern lifestyle attracts diverse travelers. Its scenic ghats and temples add charm. Nashik is Pune’s versatile outstation blend of devotion and leisure."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur, 230 km from Pune, is a historic city known for the Mahalaxmi Temple, one of the Shakti Peethas. Panhala Fort, Rankala Lake, and Bhavani Mandap showcase its heritage. Food lovers savor spicy Kolhapuri cuisine and authentic chappals. The city also celebrates cultural festivals with grandeur. Pilgrims and history enthusiasts alike are drawn to its richness. Kolhapur is Pune’s outstation hub of culture, devotion, and tradition."
  },
  {
    "title": "Goa",
    "description": "Goa, 450 km from Pune, is India’s top holiday destination for beaches, churches, and nightlife. North Goa offers vibrant parties, water sports, and shopping, while South Goa is known for serene beaches and luxury resorts. Dudhsagar Waterfalls and spice plantations add to the experience. The road trip from Pune via Kolhapur is scenic and enjoyable. Goa is Pune’s ultimate outstation vacation for fun, relaxation, and adventure."
  },
  {
    "title": "Bhimashankar",
    "description": "Bhimashankar, 110 km from Pune, is one of the 12 Jyotirlingas dedicated to Lord Shiva. The ancient temple is surrounded by the Bhimashankar Wildlife Sanctuary, home to the giant Indian squirrel. Trekkers enjoy the trails through forests, valleys, and waterfalls, especially in monsoon. Pilgrims find peace and blessings at the sacred shrine. Nature lovers admire the biodiversity and misty landscapes. Bhimashankar is Pune’s outstation blend of devotion and adventure."
  }
],


      "services": [
    {
      "name": "Outstation Urbania Hire Pune",
      "description": "Book our reliable Urbania vans for outstation trips starting from Pune, designed to offer maximum comfort on long journeys. Whether it’s a family vacation, corporate retreat, or group excursion, our well-maintained vans ensure a smooth and safe ride across Maharashtra and beyond. Enjoy spacious interiors, ample luggage space, and friendly drivers who prioritize your convenience and punctuality."
    },
    {
      "name": "Long Distance Urbania Rental Pune",
      "description": "Travel long distances effortlessly with our Urbania rental service from Pune. Our vans are perfect for journeys to destinations such as Goa, Mumbai, Shirdi, Mahabaleshwar, and more. Equipped with comfortable seating, powerful air conditioning, and advanced suspension systems, these vehicles minimize travel fatigue and enhance passenger experience on highways and hilly terrains alike."
    },
    {
      "name": "AC Urbania Van for Travel",
      "description": "Experience cool and refreshing travel with our air-conditioned Urbania vans, available for outstation rentals from Pune. The AC system maintains an optimal temperature throughout the trip, ensuring passengers remain comfortable irrespective of external weather conditions. Ideal for summer travel, corporate events, and VIP transport, these vans also feature sound insulation and adjustable seating."
    },
    {
      "name": "Force Urbania with Driver Pune",
      "description": "Hire a Force Urbania van with a professional driver for your outstation needs from Pune. Our drivers are experienced, punctual, and familiar with key routes and shortcuts, ensuring a hassle-free journey. The package includes fuel, toll charges, and driver allowances, allowing you to focus entirely on your trip while we handle the logistics and driving safety."
    },
    {
      "name": "13/17 Seater Urbania for Outstation",
      "description": "Choose from 13 or 17 seater Urbania vans tailored for outstation travel, perfect for family trips, group tours, and corporate travel. These vans offer ample legroom, comfortable reclining seats, and sufficient luggage compartments. With safety features like seatbelts, emergency exits, and GPS tracking, your journey is secure and well-monitored."
    },
    {
      "name": "Corporate Outstation Travel Urbania",
      "description": "Opt for our premium Urbania vans for corporate outstation travel from Pune. Whether it’s team-building retreats, client meetings in distant cities, or industry conferences, our vans ensure punctuality, professionalism, and comfort. Equipped with Wi-Fi, charging points, and clean interiors, they support productivity even on the move."
    },
    {
      "name": "Weekend Outstation Urbania Hire",
      "description": "Plan your weekend getaway with our flexible Urbania van hire service for outstation trips from Pune. Ideal for quick escapes to hill stations, beach resorts, or heritage sites, this package offers customizable pick-up and drop-off times, stopover options, and competitive pricing. Enjoy hassle-free travel with our dedicated support and well-maintained vehicles."
    },
    {
      "name": "Urbania Van for Group Tours",
      "description": "Organize seamless group tours with our spacious Urbania vans designed to accommodate up to 17 passengers. Perfect for clubs, educational trips, or social gatherings, our vans provide a comfortable environment with amenities such as onboard entertainment systems and ample storage. Coordinated group travel ensures everyone arrives together and on time."
    },
    {
      "name": "Urbania Family Trip Rental Pune",
      "description": "Make family trips memorable with our Urbania vans that prioritize comfort and safety. Whether it’s a religious pilgrimage, holiday outing, or weekend picnic, our vans provide child-friendly features, wide aisles for easy movement, and courteous drivers attentive to your family’s needs. Enjoy peace of mind with clean, sanitized vehicles and flexible booking options."
    },
    {
      "name": "Urbania Outstation Ride Service",
      "description": "Avail our professional Urbania ride service for outstation travel from Pune, featuring punctual pickups, well-trained drivers, and door-to-door service. Perfect for solo travelers or small groups wanting hassle-free, reliable transport with minimal planning. Our dedicated customer support ensures a smooth booking process and on-trip assistance."
    },
    {
      "name": "Urbania Tour Packages Pune",
      "description": "Choose from a variety of Urbania tour packages for popular outstation destinations from Pune. Packages include vehicle rental, driver services, itinerary planning, and optional guided tours. Explore places like Lonavala, Mahabaleshwar, Goa, and more with comfort and convenience. Tailored packages suit leisure travelers, adventure groups, and corporate outings."
    },
    {
      "name": "Pune to Outstation Urbania Booking",
      "description": "Book your Urbania van online for trips from Pune to any outstation destination with ease and transparency. Our platform offers instant availability checks, secure payments, and multiple vehicle options. Whether planning well in advance or last-minute travel, we provide competitive rates and flexible cancellation policies to suit your needs."
    },
    {
      "name": "Multi-Day Trip Urbania Van Pune",
      "description": "Plan multi-day trips from Pune with our Urbania vans, offering extended rental options for long journeys. Perfect for tours that span several days, our service includes driver accommodations, fuel management, and route optimization. Stay relaxed knowing your transport is handled by professionals focused on safety and comfort throughout your trip."
    }
  ],
  "tableData": [
    ["Outstation Urbania Hire Pune", "Long Distance Urbania Rental Pune"],
    ["AC Urbania Van for Travel", "Force Urbania with Driver Pune"],
    ["13/17 Seater Urbania for Outstation", "Corporate Outstation Travel Urbania"],
    ["Weekend Outstation Urbania Hire", "Urbania Van for Group Tours"],
    ["Urbania Family Trip Rental Pune", "Urbania Outstation Ride Service"],
    ["Urbania Tour Packages Pune", "Pune to Outstation Urbania Booking"],
    ["Multi-Day Trip Urbania Van Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Urbania Hire for Outstation in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers premium Force Urbania vans on hire for outstation trips from Pune, perfect for comfortable and luxurious long-distance travel."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our Urbania vehicles feature plush seats, ample legroom, and air conditioning to ensure a relaxed journey for all passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Fleet",
    "WhyChoosedescription": "All Urbania vans are regularly serviced and thoroughly cleaned to guarantee hygiene, safety, and reliability."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Outstation Expertise",
    "WhyChoosedescription": "Our professional chauffeurs are skilled in handling long-distance routes and ensure timely and safe travel."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options tailored to your outstation travel needs."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Our pricing includes fuel, tolls, driver allowance, and taxes for a hassle-free and transparent experience."
  },
  {
    "WhyChooseheading": "Ideal for Family Trips, Corporate Tours, and Group Travel",
    "WhyChoosedescription": "Perfect for weekend getaways, business travel, and group outings beyond Pune."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
    "WhyChoosedescription": "Our customer support team is available round-the-clock to assist with bookings, itinerary changes, and travel queries."
  }
]


























  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 13 seater Force Urbania on rent for outstation trips from Pune?',
      answer: 'Yes, Vaishnavi Travels provides 13 seater Force Urbania vehicles for outstation trips from Pune, suitable for family vacations, group tours, and corporate travel to various destinations.',
    },
    {
      question: 'What features does the 13 seater Force Urbania offer for outstation travel from Pune?',
      answer: 'The 13 seater Force Urbania includes spacious seating, air-conditioning, comfortable legroom, modern interiors, and ample luggage space, ensuring a comfortable and relaxing journey on long-distance trips.',
    },
    {
      question: 'Are the vehicles and drivers reliable for outstation rentals from Pune?',
      answer: 'Absolutely! All vehicles are well-maintained and regularly serviced. Our experienced and courteous drivers are familiar with popular outstation routes and ensure safe and timely travel.',
    },
    {
      question: 'What is the rental cost for hiring a 13 seater Force Urbania for outstation trips from Pune?',
      answer: 'Rental costs for outstation trips typically start from ₹7,000, varying based on distance, duration, and any additional services requested.',
    },
    {
      question: 'Can I book the 13 seater Force Urbania for multi-day outstation trips?',
      answer: 'Yes, Vaishnavi Travels offers flexible packages for multi-day outstation trips with clear pricing and customizable itineraries.',
    },
    {
      question: 'How early should I book a 13 seater Urbania for outstation travel from Pune?',
      answer: 'It is recommended to book at least 3-4 days in advance, especially during peak travel seasons and holidays, to secure your booking.',
    },
    {
      question: 'Is flexible pickup and drop-off available for outstation Urbania rentals from Pune?',
      answer: 'Yes, flexible pickup and drop locations are available in Pune and surrounding areas to accommodate your travel plans.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Anil Deshpande",
    position: "Tour Operator",
    feedback:
      "We hired a 13 seater Urbania from Vaishnavi Travels for an outstation group tour from Pune. The vehicle was comfortable, clean, and the driver was professional and knowledgeable about the route.",
    rating: 5,
  },
  {
    name: "Ms. Meera Kulkarni",
    position: "Travel Enthusiast",
    feedback:
      "Our outstation trip from Pune was smooth and enjoyable thanks to Vaishnavi Travels. The Urbania provided ample space and comfort for our group, and the service was excellent.",
    rating: 5,
    style: "style-2",
  }
];





































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Outstation in Pune",
  "image": "https://vaishnavitravel.com/assets/images/outstation-urbania-hire-pune.jpg",
  "description": "Book AC and Non-AC 13/17 seater Force Urbania vans for outstation trips from Pune. Ideal for long-distance travel, corporate tours, weekend getaways, and group tours with driver included.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "350"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7000",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/urbania-hire-outstation-pune"
  }
};



  return (
    <div>

<Helmet>
  <title>Urbania Hire for Outstation in Pune | 13/17 Seater AC & Non-AC Vans</title>
  <meta
    name="description"
    content="Book AC and Non-AC 13/17 seater Force Urbania vans for outstation trips from Pune. Ideal for long-distance travel, corporate tours, weekend getaways, and group tours with driver included."
  />
  <meta
    name="keywords"
    content="Outstation Urbania Hire Pune, Long Distance Urbania Rental Pune, AC Urbania Van for Travel, Force Urbania with Driver Pune, 13/17 Seater Urbania for Outstation, Corporate Outstation Travel Urbania, Weekend Outstation Urbania Hire, Urbania Van for Group Tours, Urbania Family Trip Rental Pune, Urbania Outstation Ride Service, Urbania Tour Packages Pune, Pune to Outstation Urbania Booking, Multi-Day Trip Urbania Van Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniahireforoutstationinpune;